import React from "react";
import Explanation from "./Explanation";
import {WithTranslation, withTranslation} from "react-i18next";

/**
* Interface inheriting the translation module.
* We put all the props of the component there.
**/
interface Props extends WithTranslation {
    elementTitle: string
}

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 26/04/2022
 * @last_update 26/04/2022
 **/
class IdentificationExplanation extends React.Component<Props> {

    render() {


        return (
            <Explanation>
                {this.props.t("utils.alert.explanation.identification", {title: this.props.elementTitle})}
            </Explanation>

        );

    };

}

export default withTranslation()(IdentificationExplanation);
